import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

export default function SendInvoice(props) {

  if(props.status == 'Completed'){
  return (
    <> 
    <div>
      <butto class="styles_button__1T2PZ" style={{cursor: 'pointer',padding:'1px 6px',float: 'left', backgroundColor: '#528ff0', color: '#fff', borderRadius: '3px', fontSize: '11px', marginBottom: '2px'}} onClick={() =>
              window.open(
                `${AWS_SERVER_APIS}/sendinvoicetocustomer?sub_id=${props.orderId}`,
                "_blank"
              )
            }>Send</butto>
    </div>
    <div>
      <butto class="styles_button__1T2PZ" style={{cursor: 'pointer',padding:'1px 6px',float: 'left', backgroundColor: '#528ff0', color: '#fff', borderRadius: '3px', fontSize: '11px', marginBottom: '2px'}} onClick={() =>
              window.open(
                `${AWS_SERVER_APIS}/viewinvoice?sub_id=${props.orderId}`,
                "_blank"
              )
            }>View</butto>
    </div>
    </>
  );
  }else{
    return (
      <></>
    )
  }
}
